<template>
    <div class="duplicate-project modal is-active" :class="{'cursor-wait':processStarted&&!procesFinished}">
        <div class="modal-background" />
        <div class="modal-content">
            <div class="box">
                <p class="is-size-5 has-text-centered has-text-black">
                    {{ $t('duplicate_project_title') }} {{project.title}}
                </p>
                <p class="is-size-6 has-text-centered pt-2 secondary-font">
                    {{ $t('duplicate_project_subtitle') }}
                </p>
                <div class="field px-6 pt-4" v-if="processStarted">
                    <p class="control secondary-font" v-if="!projectImported&&!importingObjects&&!procesFinished">
                        {{$t('duplication.processing_project')}}
                    </p>
                    <p class="control secondary-font" v-else-if="projectImported&&!importingObjects&&!procesFinished">
                        {{$t('duplication.project_processed')}}
                    </p>
                    <p class="control secondary-font" v-else-if="projectImported&&importingObjects&&!procesFinished">
                        {{$t('duplication.processing_objects')}}
                    </p>
                    <p class="control secondary-font" v-else-if="procesFinished">
                        {{$t('duplication.finishedProcess')}}
                    </p>
                    
                    <div
                        class="is-fullwidth"
                        style="width: 100%"
                    >
                        <progress
                            class="progress is-small"
                            :value="objectsProcessed"
                            max="100"
                        >
                            20%
                        </progress>
                    </div>
                </div>
                
                
                <div class="has-text-centered pt-4">
                    <button  v-if="!procesFinished"
                        class="
                            button
                            px-6
                            is-primary
                            primary-font
                            is-radiusless
                            is-inline-block
                        "
                        @click="startDuplication"
                        :disabled="processStarted"
                    >
                        {{ $t('Buttons.duplicate') }}
                    </button>
                    <button v-else
                        class="
                            button
                            px-6
                            is-primary
                            primary-font
                            is-radiusless
                            is-inline-block
                        "
                        @click="close"
                    >
                        {{ $t('Buttons.close') }}
                    </button>
                    <button v-if="!procesFinished"
                        class="
                            button
                            px-6
                            is-black
                            primary-font
                            is-radiusless
                            is-inline-block
                            ml-4
                        "
                        @click="$emit('close')"
                        :disabled="processStarted"
                    >
                        {{ $t('Buttons.cancel') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'underscore';
import { duplicateProject, fetchItems, duplicateObject, reassignTriggers } from '@/services/API';

export default {
    components: {},
    props: {
        project: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    data() {
        return {
            objectsProcessed: 0,
            processStarted: false,
            projectImported: false,
            importingObjects: false,
            procesFinished: false,
            projectData: {},
        };
    },
    computed: {},
    mounted() {},
    methods: {
        async startDuplication() {
            // console.log("start duplication of project",this.project.title);
            this.processStarted=true;
            let response = await duplicateProject(this.project._id)
                .catch(() => {
                    return this.$emit('error');
                })
                .finally(() => {
                    // this.uploading = false;
                });
            if (response.data) {
                this.projectData = response.data
                this.projectImported=true;
                this.objectsProcessed=10;
                // console.log("project duplication success.",response.data);
                // console.log("Initialitzing duplicate objects process");
                let items = await fetchItems('object', {
                    project: this.project._id,
                });
                
                if(items.data.length){
                    //this.importingObjects = true;
                    let relatedIds=[];
                    let increment = 90 / items.data.length;
                    // console.log("increment",increment)
                    for(let i = 0; i<items.data.length;i++){
                        
                        // console.log("duplicating object id",items.data[i]._id);
                        // this.objectsProcessed=this.objectsProcessed+increment;
                        let duplicated = duplicateObject(response.data._id, items.data[i]._id)
                        .catch(() => {
                            return this.$emit('error');
                        })
                        .then((res)=>{
                            this.importingObjects = true;
                            // console.log(res.data)
                            //relatedIds[items.data[i]._id]=res.data._id;
                            //relatedIds.push({old:items.data[i]._id,new:res.data._id})
                            this.objectsProcessed=this.objectsProcessed+increment;
                            relatedIds.push([items.data[i]._id,res.data._id]);
                            // console.log("item",i,"of",items.data.length,"processed")

                            if(items.data.length==Object.keys(relatedIds).length){
                                
                                // console.log("All objects indexed");
                                if(response.data.type=="treasurehunt"){
                                    // console.log("sendig triggers",relatedIds);
                                    //let reassigned = reassignTriggers(response.data._id, JSON.stringify(relatedIds))
                                    let reassigned = reassignTriggers(response.data._id, JSON.stringify(relatedIds))
                                    .catch(() => {
                                        return this.$emit('error');
                                    })
                                    .then((res)=>{
                                        // console.log(res.data)
                                        //relatedIds[items.data[i]._id]=res.data._id;
                                        this.procesFinished=true;
                                    })
                                    
                                }else{
                                    this.procesFinished=true;
                                }
                            }
                            
                        })
                        .finally(() => {
                            //console.log(items.data.length,Object.keys(relatedIds).length)
                            /*if(items.data.length==Object.keys(relatedIds).length){
                                
                                console.log("All objects indexed");
                                if(response.data.type=="treasurehunt"){
                                    console.log("sendig triggers",relatedIds);
                                    //let reassigned = reassignTriggers(response.data._id, JSON.stringify(relatedIds))
                                    let reassigned = reassignTriggers(response.data._id, JSON.stringify(relatedIds))
                                    .catch(() => {
                                        return this.$emit('error');
                                    })
                                    .then((res)=>{
                                        // console.log(res.data)
                                        //relatedIds[items.data[i]._id]=res.data._id;
                                        this.procesFinished=true;
                                    })
                                    
                                }else{
                                    this.procesFinished=true;
                                }
                            }*/
                             
                        });
                    }
                    /*items.data.forEach(object => {
                        console.log("duplicating object id",object._id);
                        this.objectsProcessed=this.objectsProcessed+increment;
                        let duplicated = duplicateObject(response.data._id, object._id)
                        .catch(() => {
                            return this.$emit('error');
                        })
                        .then((res)=>{
                            // console.log(res.data)
                            relatedIds[object._id]=res.data._id;
                            
                        })
                        .finally(() => {
                            // this.uploading = false;
                            //console.log("lengths",items.data.length,importedItems.length);
                            this.procesFinished=true;
                            console.log(items.data.length,relatedIds.length)
                            if(items.data.length==relatedIds.length){
                                console.log("All objects indexed")
                            }
                             
                        });
                     
                    });*/
                    // console.log(relatedIds);
                }else{
                    console.log("no objects to import");
                    this.importingObjects = true;
                    this.objectsProcessed=100;
                    this.procesFinished=true;
                }
                
            }

        },
        close(){
            this.$emit('add-project',this.projectData);
            this.$emit('close');
        }
    },
};
</script>

<style scooped>
.duplicate-project .modal-content{
    max-width: 40%;
}
.duplicate-project .modal-content .box{
    border-radius: 0px;
    padding: 35px;
}
.cursor-wait{
    cursor:wait;
}
</style>
